import Color from "color";
import React from "react";
import { FlexAlignType } from "react-native";
import { ContentView, ContentImage, ContentText, ContentPressableNavigator, ContentBlurhash, ContentBlurView, CollectionProps, ContentCollection } from "../../../../content/components";
import { ResizeMode } from "../../../knobs/types";

export const CollectionHorizontalListItem = React.memo((
    props: {
        viewsHeight: number,
        viewsMargins: number,
        borderRadius: number,
        showShadow?: boolean,
    } & CollectionProps
) => {

    return (
        <ContentView style={{
            height: props.viewsHeight,
            marginRight: props.viewsMargins,
            marginBottom: props.viewsMargins,
            borderRadius: props.borderRadius,
            shadowOpacity: props.showShadow ? 0.5 : undefined,
            shadowRadius: props.showShadow ? 6 : undefined,
            overflow: 'hidden',
            width: 172
        }}>
            <ContentCollection
                id={props.id}
                caption={props.caption}
                textColor={props.textColor}
                textAlign={props.textAlign}
                showCaption={props.showCaption}
                placeholderImage={props.placeholderImage}
                showTextBackground={props.showTextBackground}
                fontWeight={props.fontWeight}
                viewType={props.viewType}
                imageResizeMode={props.imageResizeMode as ResizeMode}
                blurIntencity={props.blurIntencity}
            />
        </ContentView>
    );
})